import { Fragment, type FC } from 'react';
import { observer } from 'mobx-react-lite';
import type { Survey } from '../logic';
import { QuestionText } from '../QuestionText';
import { AnswersView } from './AnswersView';
import { UserComment } from './UserComment';
import { NextQuestionButton } from './NextQuestionButton';
import { ValidationErrorToast } from './ValidationErrorToast';
import styles from './QuestionView.module.scss';

export const QuestionView: FC<{ survey: Survey }> = observer(({ survey }) => {
  const { currentQuestionModel } = survey;
  const { question } = currentQuestionModel;

  return (
    //  key указываем, чтобы избежать проблем с остаточным внутренним состоянием компонентов (например: TextFieldBaseLong, TextFieldBase)
    <Fragment key={question.id}>
      <QuestionText question={question} />

      <AnswersView questionModel={currentQuestionModel} />

      <UserComment questionModel={currentQuestionModel} className={styles.UserComment} />

      <NextQuestionButton survey={survey} className={styles.NextQuestionButton} />

      <ValidationErrorToast questionModel={currentQuestionModel} className={styles.ValidationErrorToast} />
    </Fragment>
  );
});
